module.exports = __webpack_public_path__ + "img/hket-20210602.19cde5ea.jpg";